import styled from "@emotion/styled"
import Div100vh from "components/Div100vh"

export default styled(Div100vh)`
  display: flex;
  ${({ theme }) => theme.breakpoints.down("xs")} {
    flex-direction: column;
  }
`
